import { c as _c } from "react/compiler-runtime";
import { FeedbackDialog } from "@flat-ui";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useFeedback } from "@hooks/feedback/use-feedback";
import { contactSupport } from "@utils/email-utils";
import { ContactSupportLocations } from "@custom-types/types";
import { runtimeConfig } from "@src/runtime-config";
import { FeedbackModalEvents } from "@utils/track-event/track-event-list";

/** The type of feedback dialog */

/**
 * SendFeedbackDialog is a modal component that allows users to provide feedback on their experience with the dashboard.
 */
export function SendFeedbackDialog(t0) {
  const $ = _c(27);
  const {
    type: t1,
    isDialogOpen,
    onClose,
    title,
    featureName: t2,
    feedbackQuestionText,
    onSubmitFeedback,
    onCancel,
    confirmText,
    cancelText,
    showXButton
  } = t0;
  const type = t1 === undefined ? "emotion" : t1;
  const featureName = t2 === undefined ? "General" : t2;
  const {
    trackEvent
  } = useTrackEvent();
  const {
    sendFeedback
  } = useFeedback();
  let t3;
  if ($[0] !== featureName || $[1] !== onClose || $[2] !== onSubmitFeedback || $[3] !== sendFeedback) {
    t3 = async function handleFeedbackSubmit(rating, feedbackText, hasUserAllowedContact) {
      await sendFeedback({
        featureName,
        feedbackMessage: feedbackText,
        selectedRating: rating,
        hasUserAllowedContact
      });
      onClose();
      onSubmitFeedback?.();
    };
    $[0] = featureName;
    $[1] = onClose;
    $[2] = onSubmitFeedback;
    $[3] = sendFeedback;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleFeedbackSubmit = t3;
  let t4;
  if ($[5] !== onClose || $[6] !== trackEvent) {
    t4 = function handleContactSupportClick() {
      contactSupport({
        location: ContactSupportLocations.feedbackDialog,
        trackEvent
      });
      onClose();
    };
    $[5] = onClose;
    $[6] = trackEvent;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleContactSupportClick = t4;
  let t5;
  if ($[8] !== onCancel || $[9] !== onClose || $[10] !== trackEvent) {
    t5 = function handelCancelClick() {
      trackEvent({
        name: FeedbackModalEvents.cancelFeedback
      });
      onCancel?.();
      onClose();
    };
    $[8] = onCancel;
    $[9] = onClose;
    $[10] = trackEvent;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handelCancelClick = t5;
  let t6;
  if ($[12] !== onClose || $[13] !== trackEvent) {
    t6 = function handelCloseClick() {
      trackEvent({
        name: FeedbackModalEvents.closeFeedbackDialog
      });
      onClose();
    };
    $[12] = onClose;
    $[13] = trackEvent;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const handelCloseClick = t6;
  let t7;
  if ($[15] !== cancelText || $[16] !== confirmText || $[17] !== feedbackQuestionText || $[18] !== handelCancelClick || $[19] !== handelCloseClick || $[20] !== handleContactSupportClick || $[21] !== handleFeedbackSubmit || $[22] !== isDialogOpen || $[23] !== showXButton || $[24] !== title || $[25] !== type) {
    t7 = <FeedbackDialog type={type} title={title} isDialogOpen={isDialogOpen} feedbackQuestionText={feedbackQuestionText} supportMailAddress={runtimeConfig.mailSupportAddress} onContactSupportClick={handleContactSupportClick} onSubmitFeedback={handleFeedbackSubmit} onCancel={handelCancelClick} onClose={handelCloseClick} confirmText={confirmText} cancelText={cancelText} showXButton={showXButton} />;
    $[15] = cancelText;
    $[16] = confirmText;
    $[17] = feedbackQuestionText;
    $[18] = handelCancelClick;
    $[19] = handelCloseClick;
    $[20] = handleContactSupportClick;
    $[21] = handleFeedbackSubmit;
    $[22] = isDialogOpen;
    $[23] = showXButton;
    $[24] = title;
    $[25] = type;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
}